export enum ReservationStayTypesEnum {
  upcoming = 'upcoming_stay',
  rest = 'rest_stay',
  cancelled = 'cancelled_stay',
}
